import { type MotifComponent, type MotifComponentProps, m } from '../../motif';
import { footerBlackBgVars, footerGrayBgVars, footerWhiteBgVars } from './Footer.palette';

export const snapFooterPrimaryVars: MotifComponentProps<MotifComponent.FOOTER> = {
  ...footerWhiteBgVars,
  '--footer-bg-color': m('--bg-color'),
  '--footer-bar-bg-color': m('--bg-color'),
  '--footer-bar-header-desktop-font-text-transform': 'uppercase',
  '--footer-bar-header-mobile-font-text-transform': 'uppercase',
  '--footer-bar-header-font-weight': '600',
  '--footer-border-color': m('--neutral-v700'),
  '--footer-divider-border-color': m('--neutral-v700'),
  '--footer-bar-divider-border-color': m('--neutral-v700'),
} as const;

export const snapFooterSecondaryVars: MotifComponentProps<MotifComponent.FOOTER> = {
  ...footerBlackBgVars,
  '--footer-bg-color': m('--neutral-v700'),
  '--footer-bar-bg-color': m('--neutral-v700'),
  '--footer-bar-header-desktop-font-text-transform': 'uppercase',
  '--footer-bar-header-mobile-font-text-transform': 'uppercase',
  '--footer-bar-header-font-weight': '600',
  '--footer-border-color': m('--neutral-v0'),
  '--footer-divider-border-color': m('--neutral-v0'),
  '--footer-bar-divider-border-color': m('--neutral-v0'),
} as const;

export const snapFooterTertiaryVars: MotifComponentProps<MotifComponent.FOOTER> = {
  ...footerGrayBgVars,
  '--footer-bg-color': m('--bg-color'),
  '--footer-bar-bg-color': m('--bg-color'),
  '--footer-bar-header-desktop-font-text-transform': 'uppercase',
  '--footer-bar-header-mobile-font-text-transform': 'uppercase',
  '--footer-bar-header-font-weight': '600',
  '--footer-border-color': m('--neutral-v700'),
  '--footer-divider-border-color': m('--neutral-v700'),
  '--footer-bar-divider-border-color': m('--neutral-v700'),
} as const;
